"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";

const CHUNK_RELOAD_KEY = "chunk_error_reload_count";
const MAX_RELOADS = 1;

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    Sentry.captureException(error);

    // Handle chunk loading errors with reload protection
    if (
      error.message.includes("Failed to load chunk") ||
      error.message.includes("Loading chunk")
    ) {
      const reloadCount = parseInt(
        sessionStorage.getItem(CHUNK_RELOAD_KEY) || "0",
        10
      );

      if (reloadCount < MAX_RELOADS) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, String(reloadCount + 1));
        window.location.reload();
      } else {
        // Reset counter after 30 seconds to allow retry later
        setTimeout(() => {
          sessionStorage.removeItem(CHUNK_RELOAD_KEY);
        }, 30000);
      }
    }
  }, [error]);

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
